import { ChatPanel } from '../components/ChatPanel';

export function ChatPage() {
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{ padding: '12px 20px', background: '#161b22', borderBottom: '1px solid #30363d' }}
      >
        <h2 style={{ fontSize: 16, fontWeight: 600, color: '#c9d1d9' }}>AI Chat</h2>
        <span style={{ fontSize: 12, color: '#8b949e' }}>Powered by Ollama / Aether Host</span>
      </div>
      <div style={{ flex: 1 }}>
        <ChatPanel />
      </div>
    </div>
  );
}
